import React,{useEffect,useState} from 'react';
import "../node_modules/bootstrap/dist/css/bootstrap.css"
import AutoAddress from "./components/AutoAddress";
import Setting from './components/Setting';
export const ZOHO =window.ZOHO;

export var Module,ApiKey;
export var Accounts_City,Accounts_Country,Accounts_State,Accounts_Street,Accounts_Zip_Code,Accounts_Street_Number,Accounts_StreetFull,Accounts_Neighborhood,Accounts_Latitude,Accounts_Longitude;
export let Contacts_City,Contacts_Country,Contacts_State,Contacts_Street,Contacts_Zip_Code,Contacts_Street_Number,Contacts_StreetFull,Contacts_Neighborhood,Contacts_Latitude,Contacts_Longitude;
export var Leads_City,Leads_Country,Leads_State,Leads_Street,Leads_Zip_Code,Leads_Street_Number,Leads_StreetFull,Leads_Neighborhood,Leads_Latitude,Leads_Longitude;
export var CustomModule1_ApiName,CustomModule1_City,CustomModule1_Country,CustomModule1_State,CustomModule1_Street,CustomModule1_Zip_Code,CustomModule1_Street_Number,CustomModule1_StreetFull,CustomModule1_Neighborhood,CustomModule1_Latitude,CustomModule1_Longitude;
export var CustomModule2_ApiName,CustomModule2_City,CustomModule2_Country,CustomModule2_State,CustomModule2_Street,CustomModule2_Zip_Code,CustomModule2_Street_Number,CustomModule2_StreetFull,CustomModule2_Neighborhood,CustomModule2_Latitude,CustomModule2_Longitude;

function App() {
  // const google = window.google;
  const [page,setPage] = useState("AutoAddress");
  const ChangePageHandler = (state) => {
    setPage(state)
  }

  useEffect(()=>{

    ZOHO.embeddedApp.on("PageLoad", function (data) {

      ZOHO.CRM.UI.Resize({height:"500",width:"800"})
  
      Module = data.Entity;

      var apiList  = {
        apiKeys:
        [
          "findaddressforzohocrmbygoogle__Google_Api_Key",
          "findaddressforzohocrmbygoogle__Leads_Module",
          "findaddressforzohocrmbygoogle__Contacts_Module",
          "findaddressforzohocrmbygoogle__Accounts_Module",
          "findaddressforzohocrmbygoogle__Custom_Module_1",
          "findaddressforzohocrmbygoogle__Custom_Module_2",
          "findaddressforzohocrmbygoogle__Custom_Module_1_Value",
          "findaddressforzohocrmbygoogle__Custom_Module_2_Value"
        ]
      };
      ZOHO.CRM.API.getOrgVariable(apiList)
      .then(function(data){
        ApiKey = data.Success.Content.findaddressforzohocrmbygoogle__Google_Api_Key.value;

        //get org variable for Accounts
        var AccountsModule = data.Success.Content.findaddressforzohocrmbygoogle__Accounts_Module.value;
        var accounts_data = JSON.parse(AccountsModule);
        Accounts_StreetFull = accounts_data[0].ApiName;
        Accounts_Street = accounts_data[1].ApiName;
        Accounts_Street_Number = accounts_data[2].ApiName;
        Accounts_Neighborhood = accounts_data[3].ApiName;
        Accounts_Zip_Code = accounts_data[4].ApiName;
        Accounts_City = accounts_data[5].ApiName;
        Accounts_State = accounts_data[6].ApiName;
        Accounts_Country = accounts_data[7].ApiName;
        Accounts_Latitude = accounts_data[8].ApiName;
        Accounts_Longitude = accounts_data[9].ApiName;
        //console.log(Accounts_City, Accounts_Country, Accounts_State, Accounts_Street, Accounts_Zip_Code,Accounts_StreetFull);
        
        
        // //get org variable for Contacts
        var ContactsModule = data.Success.Content.findaddressforzohocrmbygoogle__Contacts_Module.value;
        var contacts_data = JSON.parse(ContactsModule);
        Contacts_StreetFull = contacts_data[0].ApiName;
        Contacts_Street = contacts_data[1].ApiName;
        Contacts_Street_Number = contacts_data[2].ApiName;
        Contacts_Neighborhood = contacts_data[3].ApiName;
        Contacts_Zip_Code = contacts_data[4].ApiName;
        Contacts_City = contacts_data[5].ApiName;
        Contacts_State = contacts_data[6].ApiName;
        Contacts_Country = contacts_data[7].ApiName;
        Contacts_Latitude = contacts_data[8].ApiName;
        Contacts_Longitude = contacts_data[9].ApiName;
        //console.log(Contacts_City, Contacts_Country, Contacts_State, Contacts_Street, Contacts_Zip_Code);
        

        //get org variable for Leads
        var LeadsModule = data.Success.Content.findaddressforzohocrmbygoogle__Leads_Module.value;
        var leads_data = JSON.parse(LeadsModule);
        Leads_StreetFull = leads_data[0].ApiName;
        Leads_Street = leads_data[1].ApiName;
        Leads_Street_Number = leads_data[2].ApiName;
        Leads_Neighborhood = leads_data[3].ApiName;
        Leads_Zip_Code = leads_data[4].ApiName;
        Leads_City = leads_data[5].ApiName
        Leads_State = leads_data[6].ApiName;
        Leads_Country = leads_data[7].ApiName;
        Leads_Latitude = leads_data[8].ApiName;
        Leads_Longitude = leads_data[9].ApiName;
        //console.log("lead module object ",leads_data);
        //console.log(Leads_City, Leads_Country, Leads_State, Leads_Street, Leads_Zip_Code);

        //get org variable for Custom Module for 1
        CustomModule1_ApiName = data.Success.Content.findaddressforzohocrmbygoogle__Custom_Module_1.value;
        var CustomModule1 = data.Success.Content.findaddressforzohocrmbygoogle__Custom_Module_1_Value.value;
        var CustomModule1_data = JSON.parse(CustomModule1);
        CustomModule1_StreetFull = CustomModule1_data[0].ApiName;
        CustomModule1_Street = CustomModule1_data[1].ApiName;
        CustomModule1_Street_Number = CustomModule1_data[2].ApiName;
        CustomModule1_Neighborhood = CustomModule1_data[3].ApiName;
        CustomModule1_Zip_Code = CustomModule1_data[4].ApiName;
        CustomModule1_City = CustomModule1_data[5].ApiName;
        CustomModule1_State = CustomModule1_data[6].ApiName;
        CustomModule1_Country = CustomModule1_data[7].ApiName;
        CustomModule1_Latitude = CustomModule1_data[8].ApiName;
        CustomModule1_Longitude = CustomModule1_data[9].ApiName;
        //console.log(CustomModule1_ApiName, CustomModule1_City, CustomModule1_Country, CustomModule1_State, CustomModule1_Street, CustomModule1_Zip_Code, CustomModule1_Street_Number);


        //get org variable for Custom Module for 2
        CustomModule2_ApiName = data.Success.Content.findaddressforzohocrmbygoogle__Custom_Module_2.value;
        var CustomModule2 = data.Success.Content.findaddressforzohocrmbygoogle__Custom_Module_2_Value.value;
        var CustomModule2_data = JSON.parse(CustomModule2);
        CustomModule2_StreetFull = CustomModule2_data[0].ApiName;
        CustomModule2_Street = CustomModule2_data[1].ApiName;
        CustomModule2_Street_Number = CustomModule2_data[2].ApiName;
        CustomModule2_Neighborhood = CustomModule2_data[3].ApiName;
        CustomModule2_Zip_Code = CustomModule2_data[4].ApiName;
        CustomModule2_City = CustomModule2_data[5].ApiName;
        CustomModule2_State = CustomModule2_data[6].ApiName;
        CustomModule2_Country = CustomModule2_data[7].ApiName;
        CustomModule2_Latitude = CustomModule2_data[8].ApiName;
        CustomModule2_Longitude = CustomModule2_data[9].ApiName;
        //console.log(CustomModule2_ApiName, CustomModule2_City, CustomModule2_Country, CustomModule2_State, CustomModule2_Street, CustomModule2_Zip_Code, CustomModule2_Street_Number);


        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=places&key=${ApiKey}`;
        //script.async = true;
        document.body.appendChild(script);
        //console.log("script working");

      })

    });
    
    ZOHO.embeddedApp.init();
    
  },[]);
  
  return (
    <div className="App">
      {page === "AutoAddress" && <AutoAddress state={ChangePageHandler}/>}
      {page === "Setting" && <Setting state={ChangePageHandler}/>}
    </div>
  );
}

export default App;
